import { pxToRem } from '../../../../utils';
export var formLabelStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'block',
      lineHeight: v.lineHeight,
      marginBottom: v.marginBottom
    }, p.inline && {
      marginRight: pxToRem(10),
      display: 'inline'
    }, p.required && {
      '::after': {
        content: '"*"'
      }
    });
  }
};
//# sourceMappingURL=formLabelStyles.js.map
